// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "latest/css/" + "investor-configuration" + "." + "4973dddffd0eaf5cc9d2" + ".chunk.css";
};